import {Contact} from './Contact';
import {Group} from './Group';

export class Individual {
    id: number;
    external_id: string;
    device_name: string;
    first_name: string;
    last_name: string;
    full_name: string;
    associate_email: string;
    contacts: Contact[];
    preferred_contact_id: number;
    group_ownership: Group[];
    group_membership: Group[];
    active: boolean;

    constructor(source?: Individual) {
        this.id = source && source.id || null;
        this.external_id = source && source.external_id || null;
        this.device_name = source && source.device_name || null;
        this.first_name = source && source.first_name || null;
        this.last_name = source && source.last_name || null;
        this.full_name = source && source.first_name + ' ' + source.last_name || null;
        this.associate_email = source && source.associate_email || null;
        this.preferred_contact_id = source && source.preferred_contact_id || null;
        this.contacts = source && source.contacts || [];
        this.group_ownership = source && source.group_ownership || <Group[]>[{name: 'None'}];
        this.group_membership = source && source.group_membership || <Group[]>[{name: 'None'}];
        this.active = source && source.active || true;
    }
}
